<template>
  <Teleport to="body">
    <Transition enter-active-class="ease-out duration-300" enter-from-class="opacity-0" enter-to-class="opacity-100"
      leave-active-class="ease-in duration-200" leave-from-class="opacity-100" leave-to-class="opacity-0">
      <div v-if="modelValue"
        class="fixed inset-0 z-[49] bg-gray-500 dark:bg-gray-900 bg-opacity-75 dark:bg-opacity-75 transition-opacity" />
    </Transition>

    <Transition enter-active-class="ease-out duration-300"
      enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      enter-to-class="opacity-100 translate-y-0 sm:scale-100" leave-active-class="ease-in duration-200"
      leave-from-class="opacity-100 translate-y-0 sm:scale-100"
      leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
      <div v-if="modelValue" class="fixed inset-0 z-50 overflow-y-auto" @click="closeOnBackdrop">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div :class="[
            'bg-white dark:bg-dark-800 relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:my-8 border border-gray-200 dark:border-dark-700',
            sizeClasses
          ]" @click.stop>
            <!-- Modal Header -->
            <div class="px-4 py-3 border-b border-surface-200 dark:border-surface-700">
              <div class="flex items-center justify-between">
                <h3 class="text-lg font-medium text-gray-900 dark:text-dark-100">
                  <slot name="title" />
                </h3>
                <button v-if="!preventOutsideClose" type="button"
                  class="text-gray-400 dark:text-dark-400 hover:text-gray-500 dark:hover:text-dark-300"
                  @click="closeModal">
                  <span class="sr-only">Close</span>
                  <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Modal Content -->
            <div class="px-4 py-4">
              <slot name="content" />
            </div>

            <!-- Modal Footer -->
            <div class="px-4 py-3 border-t border-surface-200 dark:border-surface-700">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl'].includes(value)
  },
  preventOutsideClose: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue']);

const sizeClasses = computed(() => {
  const sizes = {
    sm: 'sm:max-w-sm',
    md: 'sm:max-w-md',
    lg: 'sm:max-w-lg',
    xl: 'sm:max-w-xl',
    '2xl': 'sm:max-w-2xl',
    '3xl': 'sm:max-w-3xl',
    '4xl': 'sm:max-w-4xl',
    '5xl': 'sm:max-w-5xl',
    '6xl': 'sm:max-w-6xl',
    '7xl': 'sm:max-w-7xl'
  };
  return sizes[props.size] || sizes.md;
});

const closeOnBackdrop = () => {
  if (!props.preventOutsideClose) {
    emit('update:modelValue', false);
  }
};
const closeModal = () => {
  emit('update:modelValue', false);
};
</script>